import React from "react";
import { Form } from "semantic-ui-react";
import Select from "react-select";
import Only from "react-only-when";
import PropTypes from "prop-types";
import styles from "./styles.less";
import cx from "classnames";

class FormDropdown extends React.Component {
  state = {
    open: false,
    isInvalid: false,
    value: ""
  };

  componentDidMount() {
    this.updateOpenState();
  }

  componentDidUpdate(prevProps) {
    if (this.props.value != prevProps.value) {
      this.updateOpenState();
    }
  }

  updateOpenState = () => {
    const { value } = this.props;
    if (!value && value != 0) {
      this.setState({
        open: false
      });
    } else {
      this.setState({
        open: true
      });
    }
  };

  onInputChange = valueObj => {
    const { name, onChange } = this.props;
    const { isInvalid } = this.state;
    if (valueObj && (valueObj.value || valueObj.value == 0) && isInvalid) {
      this.setState({
        isInvalid: false
      });
    }
    if (valueObj && valueObj.value) {
      this.setState({
        value: valueObj.value
      });
    }
    onChange && onChange(valueObj.value, name);
  };

  onInputFocus = () => {
    const { onInputFocus, name } = this.props;
    this.setState({
      open: true
    });
    onInputFocus && onInputFocus(name);
  };

  onInputBlur = () => {
    const { onInputBlur, name } = this.props;
    this.updateOpenState();
    onInputBlur && onInputBlur(this.state.value, name);
  };

  render() {
    const {
      label,
      required,
      options,
      fullLength,
      value,
      isRtl,
      disabled,
      customValidation,
      error,
      className,
      labelClassName,
      isMobileView,
      searchable
    } = this.props;

    const { open } = this.state;

    const isRequired = required ? true : false;
    const noValue = !value;

    const toRender = (
      <div className={styles.wrapper}>
        <Form.Field
          className={cx(styles.formInput, className, {
            [styles.fullLength]: fullLength,
            [styles.disabled]: disabled
          })}
        >
          {options &&
            options.length > 0 && (
              <Select
                className={cx(styles.inputElement, {
                  [styles.invalid]: error,
                  [styles.mobileView]: isMobileView
                })}
                placeholder={""}
                required={isRequired}
                onChange={this.onInputChange}
                options={options}
                isRtl={isRtl}
                clearable={false}
                searchable={searchable}
                disabled={disabled}
                isMulti={false}
                value={value}
                onFocus={this.onInputFocus}
                onBlur={this.onInputBlur}
                autoBlur
              />
            )}
          <label
            className={cx(styles.inputLabel, labelClassName, {
              [styles.open]: open
            })}
          >
            {isRequired &&
              noValue && <span className={styles.required}>*</span>}
            {label}
          </label>
        </Form.Field>
        <Only when={error || false}>
          <div className={styles.errorMessage}>{customValidation}</div>
        </Only>
      </div>
    );

    return toRender;
  }
}

FormDropdown.defaultProps = {
  isRtl: false,
  displayInOneLine: false,
  fullLength: true,
  searchable: true
};

FormDropdown.propTypes = {
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  onChange: PropTypes.func,
  onInputFocus: PropTypes.func,
  required: PropTypes.bool,
  options: PropTypes.array,
  fullLength: PropTypes.bool,
  isRtl: PropTypes.bool,
  onInputBlur: PropTypes.func,
  error: PropTypes.bool,
  disabled: PropTypes.bool,
  customValidation: PropTypes.string,
  className: PropTypes.string,
  labelClassName: PropTypes.string,
  isMobileView: PropTypes.bool,
  searchable: PropTypes.bool
};

export default FormDropdown;



// WEBPACK FOOTER //
// ./src/components/common/Form/FormDropdown/FormDropdown.js